module.exports = __webpack_public_path__ + "img/seduni.ab119995.jpg";